import { useEffect } from 'react';

export function HeroSection() {
  useEffect(() => {
    // Cargar el script del reproductor de Vimeo
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Limpiar el script cuando el componente se desmonte
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 py-12 sm:py-16 lg:py-20">
      <div className="absolute inset-0 opacity-5">
        <img
          alt=""
          className="w-full h-full object-cover object-center mix-blend-screen"
          src="https://public.readdy.ai/ai/img_res/0f97b7b948d087c5be562f84f625881a.jpg"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 lg:w-96 lg:h-96 bg-yellow-400/10 rounded-full blur-3xl -top-16 -left-16 sm:-top-24 sm:-left-24 md:-top-32 md:-left-32 lg:-top-48 lg:-left-48 animate-pulse"></div>
        <div className="absolute w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 lg:w-96 lg:h-96 bg-emerald-400/10 rounded-full blur-3xl -bottom-16 -right-16 sm:-bottom-24 sm:-right-24 md:-bottom-32 md:-right-32 lg:-bottom-48 lg:-right-48 animate-pulse"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6">
            <div className="text-center lg:text-left mb-6">
              <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-white mb-4 drop-shadow-lg leading-tight uppercase">
                COPIA MI SISTEMA <span className="text-yellow-400">SCALEUP</span>: VENDE{' '}
                <span className="text-yellow-400">PRODUCTOS DIGITALES</span> EN AUTOMÁTICO CON{' '}
                <span className="text-yellow-400">IA</span>
              </h1>
              <p className="text-xs sm:text-sm lg:text-base text-white leading-relaxed drop-shadow-md">
                La estrategia 2026 para vender  PDFs, Descargables y Herramientas usando WhatsApp y escalando con VSL y Paginas de alta convercion , sin bloqueos de Facebook y sin experiencia técnica 🚀
              </p>
            </div>

            <div className="relative w-full">
              <div className="absolute -inset-0.5 sm:-inset-1 md:-inset-2 lg:-inset-4 bg-gradient-to-r from-yellow-400 via-emerald-400 to-teal-400 rounded-lg sm:rounded-xl md:rounded-2xl lg:rounded-3xl blur-md sm:blur-lg md:blur-xl opacity-75 animate-pulse"></div>
              <div className="relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-md sm:rounded-lg md:rounded-xl lg:rounded-2xl p-0.5 md:p-1 lg:p-2 shadow-2xl">
                <div className="relative bg-gradient-to-br from-yellow-400/20 via-emerald-400/20 to-teal-400/20 rounded-md sm:rounded-lg md:rounded-xl p-0.5 md:p-1">
                  <div className="relative bg-black rounded-md sm:rounded-lg overflow-hidden shadow-inner">
                    <div className="absolute top-1.5 right-1.5 sm:top-2 sm:right-2 md:top-3 md:right-3 lg:top-4 lg:right-4 z-20 bg-red-600/95 backdrop-blur-sm rounded-full px-1.5 py-0.5 sm:px-2 sm:py-1 md:px-3 md:py-1.5 lg:px-4 lg:py-2 flex items-center gap-1 sm:gap-1.5 md:gap-2 shadow-lg">
                      <div className="relative flex items-center justify-center w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-2.5 lg:h-2.5">
                        <span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping"></span>
                        <span className="relative inline-flex rounded-full h-1 w-1 sm:h-1.5 sm:w-1.5 md:h-2 md:w-2 lg:h-2.5 lg:w-2.5 bg-red-500"></span>
                      </div>
                      <span className="text-white font-semibold text-[10px] sm:text-xs md:text-sm whitespace-nowrap">45 viendo</span>
                    </div>

                    <div className="absolute top-0 left-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-t border-l sm:border-t-2 sm:border-l-2 md:border-t-2 md:border-l-2 lg:border-t-4 lg:border-l-4 border-yellow-400 rounded-tl-md sm:rounded-tl-lg z-10"></div>
                    <div className="absolute top-0 right-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-t border-r sm:border-t-2 sm:border-r-2 md:border-t-2 md:border-r-2 lg:border-t-4 lg:border-r-4 border-emerald-400 rounded-tr-md sm:rounded-tr-lg z-10"></div>
                    <div className="absolute bottom-0 left-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-b border-l sm:border-b-2 sm:border-l-2 md:border-b-2 md:border-l-2 lg:border-t-4 lg:border-l-4 border-teal-400 rounded-bl-md sm:rounded-bl-lg z-10"></div>
                    <div className="absolute bottom-0 right-0 w-4 h-4 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-16 lg:h-16 border-b border-r sm:border-b-2 sm:border-r-2 md:border-b-2 md:border-r-2 lg:border-b-4 lg:border-r-4 border-yellow-400 rounded-br-md sm:rounded-br-lg z-10"></div>

                    <div className="hidden md:block absolute top-1/2 left-0 w-1 h-24 bg-gradient-to-b from-transparent via-yellow-400 to-transparent transform -translate-y-1/2 animate-pulse"></div>
                    <div className="hidden md:block absolute top-1/2 right-0 w-1 h-24 bg-gradient-to-b from-transparent via-emerald-400 to-transparent transform -translate-y-1/2 animate-pulse"></div>

                    <div className="relative w-full aspect-video bg-gray-900">
                      <iframe 
                        src="https://player.vimeo.com/video/1158891827?badge=0&autopause=0&player_id=0&app_id=58479" 
                        frameBorder="0" 
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                        title="Video de presentación"
                      ></iframe>
                    </div>

                    <div className="absolute -bottom-0.5 md:-bottom-1 lg:-bottom-2 left-1/2 transform -translate-x-1/2 w-3/4 h-0.5 md:h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent rounded-full"></div>
                  </div>

                  <div className="absolute -top-0.5 -left-0.5 sm:-top-1 sm:-left-1 md:-top-2 md:-left-2 lg:-top-4 lg:-left-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-yellow-400 rounded-full animate-ping"></div>
                  <div className="absolute -top-0.5 -right-0.5 sm:-top-1 sm:-right-1 md:-top-2 md:-right-2 lg:-top-4 lg:-right-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-emerald-400 rounded-full animate-ping"></div>
                  <div className="absolute -bottom-0.5 -left-0.5 sm:-bottom-1 sm:-left-1 md:-bottom-2 md:-left-2 lg:-bottom-4 lg:-left-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-teal-400 rounded-full animate-ping"></div>
                  <div className="absolute -bottom-0.5 -right-0.5 sm:-bottom-1 sm:-right-1 md:-bottom-2 md:-right-2 lg:-bottom-4 lg:-right-4 w-1 h-1 sm:w-1.5 sm:h-1.5 md:w-2 md:h-2 lg:w-3 lg:h-3 bg-yellow-400 rounded-full animate-ping"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6 sm:space-y-8">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
              <span className="text-xl sm:text-2xl">🔥</span>
              <span className="text-white text-xs sm:text-sm font-medium">Oferta de Lanzamiento - Solo por Tiempo Limitado</span>
            </div>

            <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-extrabold text-white leading-tight">
              ¡CONVIÉRTETE EN UN EXPERTO EN{' '}
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                TRÁFICO Y VENTAS DIGITALES!
              </span>
            </h2>

            <p className="text-sm sm:text-base lg:text-lg text-white/80 leading-relaxed">
              Aprende estrategias comprobadas para vender productos online TODOS LOS DÍAS con publicidad pagada, incluso si estás empezando desde cero.
            </p>

            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                </div>
                <span className="text-white text-xs sm:text-sm lg:text-base">
                  Vender productos digitales utilizando la inteligencia artificial
                </span>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                </div>
                <span className="text-white text-xs sm:text-sm lg:text-base">
                  El paso a paso desde cero para poder generar ingresos todos los meses y en tiempo récord
                </span>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-xs sm:text-sm"></i>
                </div>
                <span className="text-white text-xs sm:text-sm lg:text-base">
                  Escalar tus resultados mes a mes con una metodología comprobada por nuestros alumnos
                </span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 lg:gap-8 pt-4">
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">500+</div>
                <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Estudiantes</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white flex items-center gap-1 justify-center">
                  4.9 <i className="ri-star-fill text-yellow-400 text-lg sm:text-xl lg:text-2xl"></i>
                </div>
                <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Valoración</div>
              </div>
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">24/7</div>
                <div className="text-white/60 text-xs sm:text-sm whitespace-nowrap">Soporte</div>
              </div>
            </div>

            <div className="relative hidden lg:block mt-8">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:rotate-2 transition-transform duration-500">
                <img
                  alt="Dashboard"
                  className="w-full h-auto object-cover"
                  src="https://static.readdy.ai/image/35f0715deb3f0b80002922a6d1f4e543/ed8f4c70da48f615e6a248f14a7f4fba.png"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full blur-2xl opacity-60 animate-pulse"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full blur-2xl opacity-40 animate-pulse"></div>
              <div className="absolute top-4 -left-3 bg-yellow-400 text-gray-900 px-3 py-1.5 rounded-lg font-bold shadow-xl transform -rotate-6 text-sm whitespace-nowrap">
                ✨ Resultados Reales
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
